function elementScrollTo(element, left, behavior) {
  requestAnimationFrame(() => {
    element.scrollTo({
      left: left,
      top: 0,
      behavior: behavior ? behavior : Themu.prefersReducedMotion ? 'instant' : 'smooth',
    });
  });
}

function removeTrapBodyScroll() {
  const scrollY = document.body.style.top;

  document.body.style.paddingRight = '';
  document.body.style.overflow = 'visible';
  document.body.style.touchAction = '';

  document.body.style.top = '';

  if (scrollY === '') {
    return;
  }

  window.scrollTo(0, parseInt(scrollY || '0') * -1);

  setTimeout(() => {
    document.dispatchEvent(new Event('ce-sticky-scroll-header:unfreeze'));
  }, 100);
}

function trapBodyScroll() {
  document.dispatchEvent(new Event('ce-sticky-scroll-header:freeze'));

  document.body.style.top = `-${window.scrollY}px`;

  document.body.style.paddingRight = `${window.innerWidth - document.body.offsetWidth}px`;
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';
}

(function () {
  window.Themu = window.Themu || {};

  function mediaQueryIsViewportDesktop() {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', () => {
      Themu.isViewportDesktop = mediaQuery.matches;
    });

    return mediaQuery;
  }

  function mediaQueryPrefersReducedMotion() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    mediaQuery.addEventListener('change', () => {
      Themu.prefersReducedMotion = mediaQuery.matches;
    });

    return mediaQuery;
  }

  window.Themu = {
    ...window.Themu,
    ...{
      animation: {
        easeIn: 'cubic-bezier(0, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.4, 0, 1, 1)',
      },
      prefersReducedMotion: mediaQueryPrefersReducedMotion().matches,
      isViewportDesktop: mediaQueryIsViewportDesktop().matches,
    },
  };

  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
})();

